import createField from '../../../utils/factory/createField'
import { faUsers, faLayerGroup } from '@fortawesome/free-solid-svg-icons'

export const associeteGroupFields = [
  {
    section: 'Grupos Associados',
    fields: [
      createField({
        id: 'type_id',
        label: 'Tipo',
        type: 'select',
        disabled: true,
        placeholder: 'Selecione o tipo',
        fullWidth: true,
        icon: faUsers,
      }),
    ],
  },
]

export const groupFields = [
  {
    section: 'Informações do Grupo',
    fields: [
      createField({
        id: 'group.name',
        label: 'Nome',
        type: 'text',
        placeholder: 'Digite o nome do grupo',
        fullWidth: true,
        icon: faLayerGroup,
      }),
      createField({
        id: 'group.types',
        label: 'Tipos',
        type: 'select',
        isMulti: true,
        placeholder: 'Digite os tipos do grupo',
        fullWidth: true,
        icon: faLayerGroup,
      }),
    ],
  },
]
